import { lotStore, syncQueue } from '../../offline/indexedDBService'
import { v4 as uuidv4 } from 'uuid'
import AxiosControl from '../../components/axios/AxiosControl'
const Axios = AxiosControl()

export const getLots = (page = null, limit = null, search = '') => async (dispatch) => {
    dispatch({ type: 'LOT_LOADING' })
    try {
        const { data, status } = await Axios.post('/api/lot/getall/', { page, limit, search }, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'LOT_GETALL_SUCCESS',
                payload: data
            })
        } else {
            dispatch({ type: 'LOT_NOT_LOADING' })
        }
    } catch (error) {
        dispatch({ type: 'LOT_NOT_LOADING' })
    }
}

export const getForSelect = () => async (dispatch) => {
    dispatch({ type: 'LOT_LOADING' })
    try {
        const { data, status } = await Axios.get('/api/lot/getforselect/', {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'LOT_GETALLFORSELECT_SUCCESS',
                payload: data
            })
        } else {
            dispatch({ type: 'LOT_NOT_LOADING' })
        }
    } catch (error) {
        dispatch({ type: 'LOT_NOT_LOADING' })
    }
}

export const getReviewMarkForSelect = () => async (dispatch) => {
    dispatch({ type: 'LOT_LOADING' })
    try {
        const { data, status } = await Axios.get('/api/lot/getreviewmarkforselect/', {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'LOT_GETALLFORSELECT_SUCCESS',
                payload: data
            })
        } else {
            dispatch({ type: 'LOT_NOT_LOADING' })
        }
    } catch (error) {
        dispatch({ type: 'LOT_NOT_LOADING' })
    }
}

export const getLot = (lot) => async (dispatch) => {
    dispatch({ type: 'LOT_LOADING' })
    try {
        const { data, status } = await Axios.get('/api/lot/get/' + lot, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'LOT_GET_SUCCESS',
                payload: data
            })
        } else {
            dispatch({ type: 'LOT_NOT_LOADING' })
        }
    } catch (error) {
        dispatch({ type: 'LOT_NOT_LOADING' })
    }
}

export const addLot = (lotdata) => async (dispatch, getState) => {
	const tempId = uuidv4()
	const { zonesForSelect } = getState().zones

	if (!navigator.onLine) {
		await lotStore.setItem(tempId, lotdata)
		await syncQueue.setItem(tempId, {
			type: 'LOT_ADD_OFFLINE',
			payload: lotdata
		})
		dispatch({
			type: 'LOT_ADD_SUCCESS',
			payload: {
				lot: { ...lotdata, _id: tempId, id: tempId, offline: true,
					zone: zonesForSelect.find(zone => zone._id === lotdata.zone) || {
						_id: lotdata.zone,
						name: lotdata.zone
					}
                },
				message: 'success'
			}
		})
		return
	}

	try {
		const { data, status } = await Axios.post('/api/lot/register', lotdata, {
			headers: { auth: localStorage.getItem('jwt') }
		})
		if (status === 200) {
			dispatch({ type: 'LOT_ADD_SUCCESS', payload: data })
		} else if (status === 264 || status === 260) {
			dispatch({ type: 'LOT_WRONG_SUCCESS', payload: data })
		} else {
			dispatch({ type: 'LOT_NOT_LOADING' })
		}
	} catch (error) {
		dispatch({ type: 'LOT_NOT_LOADING' })
	}
}

export const editLot = (lotdata, lotId) => async (dispatch, getState) => {
	const { zonesForSelect } = getState().zones

    if (!navigator.onLine) {
		await lotStore.setItem(lotId, lotdata)
		await syncQueue.setItem(lotId, {
			type: 'LOT_EDIT_OFFLINE',
			payload: lotdata
		})
		dispatch({
			type: 'LOT_EDIT_SUCCESS',
			payload: {
                lot: {
                    ...lotdata,
                    _id: lotId,
                    offline: true,
					zone: zonesForSelect.find(zone => zone._id === lotdata.zone) || {
						_id: lotdata.zone,
						name: lotdata.zone
					}
                },
                message: 'editSuccess'
            }
		})
		return
	}

	try {
		const { data, status } = await Axios.put('/api/lot/edit/' + lotId, lotdata, {
			headers: { auth: localStorage.getItem('jwt') }
		})
		if (status === 200 || status === 264) {
			dispatch({ type: 'LOT_EDIT_SUCCESS', payload: data })
		}
	} catch (error) {
		dispatch({ type: 'LOT_NOT_LOADING' })
	}
}
